import type {
  UpsertMachineMutation,
  UpsertMachineMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const UPSERT_MACHINE: TypedDocumentNode<
  UpsertMachineMutation,
  UpsertMachineMutationVariables
> = gql`
  mutation UpsertMachine($input: UpsertMachineInput!) {
    upsertMachine(input: $input) {
      wasCreated
      machine {
        id
        userId
        name
        context
        initialContext
        config
        createdAt
        updatedAt
        machineInstances {
          id
          machineId
          context
          config
          state
          isComplete
          createdAt
          updatedAt
        }
      }
    }
  }
`;
